
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-conditions",
      function () {
        return require("private-next-pages/medical-conditions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-conditions"])
      });
    }
  